<template>
  <nav class="nav">
    <div class="mobile-link menu-header lawyer-menu-header">
      <NavNotification v-if="showNotification" />
      <div
        class="heading dropdown"
        @click="toggleMenu"
      >
        <img
          :src="picture"
          alt=""
          class="custom-avatar"
        >
      </div>
    </div>
    <div
      id="mobile-nav"
      class="nav-links mobile-phone-nav mobile-hide"
    >
      <div
        v-if="role == 'lawyer' || role == 'user'"
        class="nav-list"
      >
        <div class="nav-item">
          <ServiceNavLinkComponent />
        </div>
      </div>
      <router-link
        v-for="navItem in navlink"
        :key="navItem.name"
        :to="navItem.path"
        class="nav-link"
        :class="{'nrn-legal-button': navItem.name === 'NRN Legal'}"
      >
        {{ navItem.name }}
      </router-link>
      <NavNotification
        v-if="showNotification"
        id="notification"
        class="mobile-hide"
      />
      <div class="heading dropdown">
        <img
          id="profile-picture"
          :src="picture"
          alt="Profile Picture"
          class="custom-avatar"
        >
      </div>
      <div class="dropdown-links">
        <router-link
          v-for="menu in dropdownmenu"
          :key="menu.name"
          :to="menu.param? {name:menu.path,param:{id:menu.param}}:menu.path"
          class="dropdown-link"
        >
          {{ menu.name }}
        </router-link>
        <a
          id="logout"
          href="#"
          class="dropdown-link"
          @click="$emit('logout')"
        >Logout</a>
      </div>
    </div>
  </nav>
</template>

  <script>
  import NavNotification from './NavNotification.vue'
  import ServiceNavLinkComponent from '@/components/LandingPage/Header/ServiceNavLinkComponent.vue'


    /**
   * Vue Component for displaying navbar according to role of register user
   * @param {object} props
   * @param {picture} props.picture profile picture of logged in user/dummy profile image
   * @param {array} props.navlink navigation links list
   * @param {array} props.dropdownmenu menu list to be displayed on hovering/clicking profile picture
   * @returns
   */

  export default {
    name: 'LoggedInNavMenu',
    components: {
      NavNotification,
      ServiceNavLinkComponent,
    },
    props: {
      picture: {
        type: String,
        required: true,
      },
      role: {
        type: String,
        required: true,
      },
      navlink: {
        type: Array,
        required: false,
        default: ()=>[],
      },
      dropdownmenu: {
        type: Array,
        required: false,
        default: ()=>[],
      },
      showNotification: {
        type: Boolean,
        required: false,
        default: () => true,
      },
    },

    setup(props) {
      /**
       * opens and closes dropdown menu
       *
       * @return {void}
       */
      const toggleMenu = () => {
        let menu = document.querySelector('#mobile-nav')

        if (menu.classList.contains('mobile-hide')) {
          menu.classList.remove('mobile-hide')
        } else {
          menu.classList.add('mobile-hide')
        }
      }

      return {
        toggleMenu,
        props,
      }
    },
  }
  </script>
